import { intersection as _intersection } from 'lodash';

export default (a = [], b = []) => {
  const sameElementsCount = _intersection(a, b).length;
  return a.length === sameElementsCount && b.length === sameElementsCount;
};
